import Axios from 'axios';
import React, { useEffect, useState } from 'react'
import Header from '../components/Header';
import InfoList from '../components/InfoList';

export const BList = ({match}) => {
    const id=(match.params.id);
    const [data,setData]=useState({
        cates:[],
        list:{}
    });
    const loadData=async()=>{
        const res = await Axios.get(`/api/info/blist/${id}`);
        setData(res.data);
        console.log(res.data);
    }
    useEffect(()=>{
        loadData();
    },[id])
    const buildCateList=()=>{
        return data.cates.map(cate=>(
            <div key={cate.id}>
                <Header title={cate.name} to={`/list/${cate.id}`}/>
                <div>
                    <InfoList list={data.list[cate.id]} />
                </div>
            </div>
        ))
    }
    return (
        <div>
           {buildCateList()} 
        </div>
    )
}
